import React, { useState, createContext, useContext } from 'react';
export interface CatchLog {
  id: string;
  species: string;
  weight: number;
  length: number;
  locationId: string;
  date: string;
  notes: string;
  image?: string;
}
export interface AppContextType {
  favorites: string[];
  catches: CatchLog[];
  toggleFavorite: (locationId: string) => void;
  addCatch: (log: CatchLog) => void;
  navigateToMap: (locationId?: string) => void;
  activeLocationId: string | null;
  setActiveLocationId: (id: string | null) => void;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
export function AppProvider({
  children
}: {
  children: ReactNode;
}) {
  const [favorites, setFavorites] = useState<string[]>([]);
  const [catches, setCatches] = useState<CatchLog[]>([]);
  const [activeLocationId, setActiveLocationId] = useState<string | null>(null);
  const toggleFavorite = (locationId: string) => {
    setFavorites(prev => prev.includes(locationId) ? prev.filter(id => id !== locationId) : [...prev, locationId]);
  };
  const addCatch = (log: CatchLog) => {
    setCatches(prev => [log, ...prev]);
  };
  const navigateToMap = (locationId?: string) => {
    // This function will be overridden in App.tsx or handled via a separate navigation context
    // For now, we'll just set the active location if provided
    if (locationId) {
      setActiveLocationId(locationId);
    }
  };
  return <AppContext.Provider value={{
    favorites,
    catches,
    toggleFavorite,
    addCatch,
    navigateToMap,
    activeLocationId,
    setActiveLocationId
  }} data-id="element-164">
      {children}
    </AppContext.Provider>;
}
export function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}